import React, { useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
// import transactionTypes from "data/transaction-types";
import TransactionFilers from "views/pages/transaction/filters";
import RefundModal from "views/pages/transaction/refund-modal";
import CommonTable from "views/lib/components/CommonTable";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getList, refund } from "actions/transaction/actions";

const Transaction = ({
                       transactionList,
                       getList,
                       openCustomModal,
                       closeCustomModal,
                       refund,
                       loading
                     }) => {
  const handleRefundModal = useCallback(transactionId => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: "Refund",
      children: (
        <RefundModal
          onCancel={() => closeCustomModal(modalObj)}
          onSubmit={() => {
            refund(transactionId, () => {
              toast("Refunded successfully", {
                type: toast.TYPE.SUCCESS,
              });
            });
            closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  }, [openCustomModal, closeCustomModal, refund]);

  const getColumns = () => [
    {
      id: "userId",
      Header: "#",
      accessor: "userId",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/users/${original.walletId}`}>
          {original.walletId}
        </Link>
      ),
      width: 140
    },
    {
      id: "amount",
      Header: "Amount",
      accessor: "amount",
      width: 100
    },
    {
      id: "currency",
      Header: "Currency",
      accessor: "currency",
      width: 100
    },
    {
      id: "status",
      Header: "Status",
      accessor: "status",
      width: 90
    },
    {
      id: "orderNumber",
      Header: "Order #",
      accessor: "orderNumber",
      width: 90
    },
    {
      id: "startDate",
      Header: "Start Date",
      accessor: original => moment(original.startDate)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => (original.startDate ? moment(original.startDate)
        .format("HH:mm YYYY-MM-DD") : ""),
      width: 130
    },
    {
      id: "endDate",
      Header: "End Date",
      accessor: original => moment(original.endDate)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => (original.endDate ? moment(original.endDate)
        .format("HH:mm YYYY-MM-DD") : ""),
      width: 130
    },
    {
      id: "type",
      Header: "Type",
      accessor: "type",
      width: 90
    },
    {
      id: "ps-account-id",
      Header: "PS Account ID",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.paymentProviderAccountId ? (
        <Link to={`/users/${original.paymentProviderAccountId}`}>
          {original.paymentProviderAccountId}
        </Link>
      ) : ""),
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "ps-transaction-id",
      Header: "PS Transaction ID",
      Cell: ({ original }) => original.paymentProviderTransactionId || "",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "purchaseItemId",
      Header: "Purchase Item Id",
      accessor: "purchaseItemId",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "purchaseItemType",
      Header: "Purchase Item Type",
      accessor: "purchaseItemType",
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-warning"
          onClick={() => handleRefundModal(original.id)}
        >
          Refund
        </button>
      )
    },
  ];

  return (
    <CommonTable
      list={transactionList}
      getListFunction={getList}
      FiltersComponent={TransactionFilers}
      columns={getColumns()}
      loading={loading}
      searchHookProps={{
        size: 100,
        sort: "endDate,desc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  loading: state.transaction.loading,
  transactionList: state.transaction.transactionList,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
  refund: bindActionCreators(refund, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Transaction);



// WEBPACK FOOTER //
// ./src/views/pages/transaction/index.js